import { AnyDocument, DocumentTransitionsResult } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentTransitions = async (
  constructGet: ConstructGet,
  documentParams: DocumentParams<'definition' | 'workflow'>,
  documentId: AnyDocument['id'],
): Promise<NonPaginatedResponse<DocumentTransitionsResult> | undefined> =>
  constructGet<NonPaginatedResponse<DocumentTransitionsResult>>(
    `${DOCUMENTS_BASE_PATH}/${documentId}/transitions`,
    {
      headers: buildHeadersFromDocumentParams(documentParams),
    },
  );
